import { TranslateFunction } from '@wix/challenges-web-library';
import { IChallengeJoinRestriction } from '../interfaces';

interface IGetJoinRestrictionTextProps {
  t: TranslateFunction;
  challengeJoinRestrictions: IChallengeJoinRestriction[];
}

export function getJoinRestrictionText(
  args: IGetJoinRestrictionTextProps,
): string | null {
  const { t, challengeJoinRestrictions } = args;
  const firstRestriction = challengeJoinRestrictions[0];

  let restrictionContent = null;

  switch (firstRestriction) {
    case IChallengeJoinRestriction.FINISHED:
      restrictionContent = t('challenge.finished');
      break;
    case IChallengeJoinRestriction.MAX_PARTICIPANTS:
      restrictionContent = t('challenge.page.restrictions.max-participants');
      break;
    case IChallengeJoinRestriction.OFFLINE_PAYMENT_PENDING:
      restrictionContent = t('challenge.payment-request.notification');
      break;
    case IChallengeJoinRestriction.SPECIFIC_STARTED:
      restrictionContent = t('challenge.page.restrictions.specific-started');
      break;
    default:
  }

  return restrictionContent;
}
